<template>
    
    <div v-if="current">
        
        <v-row>
            <v-col cols="12" sm="4">
                <v-btn color="success" @click="dialogCheckAll()">Checagem geral</v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" sm="6">
                <v-alert dense text type="error">
                {{ counter_open }} serviços de internet para serem integrados
                </v-alert>
            </v-col>
            <v-col cols="12" sm="6">
                <v-alert dense text type="success">
                {{ counter_done }} serviços de internet totais já integrados
                </v-alert>
            </v-col>
        </v-row>

        <v-simple-table>
            <thead>
                <tr>
                <th>Nome</th>
                <th>Pendências</th>
                <th>Notificações</th>
                <th>Ações</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in current" :key="item.id">
                <td>{{ item.clientName }}</td>
                <td>
                  <v-chip v-if="!item.compelsId">CT</v-chip>
                  <v-chip v-if="!item.compelsScm && !item.compelsSva">SV</v-chip>
                </td>
                <td>
                    <span v-for="notification in item.notifications" :key="notification.index" style="margin: 2px">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-chip :color="colorNotification(notification.level)" v-bind="attrs" v-on="on">{{ notification.message }}</v-chip>
                            </template>
                            <span>{{ notification.data }}</span>
                        </v-tooltip>
                    </span>
                </td>
                <td><v-btn icon @click="compels(item.id)" title="Executar integração"><v-icon>mdi-cog</v-icon></v-btn></td>
                </tr>
            </tbody>
        </v-simple-table>

        <v-dialog v-model="dialog_compels" max-width="600">
            <v-card>
                <v-card-title>
                    Integração Compels - {{internet.clientName}}
                </v-card-title>
                <v-card-text>
                    <v-row dense>
                      <v-col>
                        <v-alert dense text type="error" v-if="internet.notifications">
                            Cliente ainda tem notificações não resolvidas!
                        </v-alert>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <span v-for="notification in internet.notifications" :key="notification.index" style="margin: 2px">
                          <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-chip :color="colorNotification(notification.level)" v-bind="attrs" v-on="on">{{ notification.message }}</v-chip>
                              </template>
                              <span>{{ notification.data }}</span>
                          </v-tooltip>
                        </span>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>Contrato</v-col>
                      <v-col><v-alert text dense :type="compelsColor(internet.compelsId)">{{ internet.compelsId | compelsStatus }}</v-alert></v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>Serviço</v-col>
                      <v-col><v-alert text dense :type="compelsColor(internet.compelsScm)">{{ internet.compelsScm | compelsStatus }}</v-alert></v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="success" v-if="!internet.notifications" @click="compelsIntegration(internet.id)">Executar Integração</v-btn>
                    <v-btn @click="dialog_compels = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_check" width="600">
          <v-card>
            <v-card-title>Checagem geral da integração de Internet</v-card-title>
            <v-card-text>
              <p>
              Executar checagem geral da integração Compels?
              </p>
              <v-alert type="warning">Essa tarefa poderá demorar 60 minutos para ser finalizada!</v-alert>
            </v-card-text>
            <v-card-actions>
              <v-btn color="success" @click="postCheckAll()">Executar</v-btn>
              <v-btn color="default" @click="dialog_check = false"
                >Cancelar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_loading" persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Por favor aguarde
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
    
</template>

<script>
import api from '../../api/index.js';
export default {
  data: () => ({
    current: [],
    internet: {},
    counter_open: 0,
    counter_done: 0,
    dialog_loading: false,
    dialog_compels: false,
    dialog_check: false
  }),
  created: function(){
      this.compelsOpen();
      this.compelsDoneCount();
  },
  methods: {
      compels: function(id){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api.get("/internet/compels/open/"+id, {headers: { Authorization: "Bearer " + token }})
        .then(function(response) {
          me.dialog_loading = false;
          me.internet = response.data;
          me.dialog_compels = true;
        })
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao recuperar cliente para integração!");
        });  
      },
      compelsIntegration: function(id){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api.post("/internet/compels/integration/"+id, null, {headers: { Authorization: "Bearer " + token }})
        .then(function(response) {
          me.dialog_loading = false;
          me.internet = response.data;
          me.compelsOpen();
        })
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao realizar integração!");
        });
      },
      compelsOpen: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api.get("/internet/compels/open", {headers: { Authorization: "Bearer " + token }})
        .then(function(response) {
            me.dialog_loading = false;
            me.current = response.data;
            me.counter_open = response.data.length;
        })
        .catch(function(error) {
            me.dialog_loading = false;
            console.log(error);
            alert("Falha ao recuperar listagem!");
        });
      },
      compelsDoneCount: function() {
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api.get("/internet/compels/done/count", {headers: { Authorization: "Bearer " + token }})
        .then(function(response) {
          //me.dialog_loading = false;
          me.counter_done = response.data;
        })
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao recuperar contagem!");
        });
      },
      dialogCheckAll: function(){
        this.dialog_check = true;
      },
      postCheckAll: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_check = false;
        me.dialog_loading = true;
        api.post("/internet/compels/check", null, {headers: { Authorization: "Bearer " + token }})
        .then(function() {
          me.dialog_loading = false;
          alert("Comando enviado com sucesso!");
        })
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao solicitar checagem!");
        });
      },
      colorNotification: function(level){
        var ret = "default"
        if(level==1){
            ret = "info";
        }else if(level==2){
            ret = "warning"
        }else if(level==3){
            ret = "error"
        }
        return ret;
      },
      compelsColor: function(status){
        var ret = "error";
        if(status){
          ret = "success";
        }
        return ret;
      }
  },
  filters: {
    compelsStatus: function(status){
      var ret = "Pendente";
      if(status){
        ret = "Integrado";
      }
      return ret;
    }
  }
}
</script>
